module.exports = __webpack_public_path__ + "static/media/lightbulb_6.935ee9fe.png";